import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { configService } from '../../services/configService';
import { getStageDisplay } from '../../utils/environment';

interface EnvironmentBadgeProps {
  /** ステージ名のみ表示（狭い領域向け） */
  compact?: boolean;
  /** 青いツールバー上など、明るい文字色で表示 */
  variant?: 'default' | 'onPrimary';
  sx?: SxProps<Theme>;
}

const EnvironmentBadge: React.FC<EnvironmentBadgeProps> = ({
  compact = false,
  variant = 'default',
  sx,
}) => {
  const stage = configService.getConfig().stage;
  const display = getStageDisplay(stage);

  if (!display) {
    return null;
  }

  const label = compact ? display.documentTitlePrefix : display.label;
  const isOnPrimary = variant === 'onPrimary';

  return (
    <Box
      component="span"
      role="status"
      aria-label={`${display.label}（本番環境ではありません）`}
      sx={{
        display: 'inline-block',
        bgcolor: isOnPrimary ? 'rgba(255, 255, 255, 0.2)' : display.bgcolor,
        color: '#FFFFFF',
        border: isOnPrimary ? '1px solid rgba(255, 255, 255, 0.8)' : 'none',
        borderRadius: '2px',
        px: compact ? 0.75 : 1,
        py: 0.5,
        fontSize: compact ? '10px' : '11px',
        fontWeight: 600,
        lineHeight: 1.2,
        letterSpacing: '0.05em',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        ...sx,
      }}
    >
      {label}
    </Box>
  );
};

export default EnvironmentBadge;
